import React, { useEffect, useState } from "react";
import BillingDetails from "../common/BillingDetails";
import SelectInput from "../common/SelectInput";
import TextAreaInput from "../common/TextAreaInput";
import TextInput from "../common/TextInput";
import FileUploadInput from "../common/FileUploadInput";
import EpInlineLoader from "../common/EpInlineLoader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import CalendarIcon from "../common/CalanderIcon";

function AddressDetails(props) {
  const { values, errors, dirty, handleOnChange, newHandleOnChange, handleFileChange, setData, navigation, t, changeLanguageArabic } =
    props;
  const {
    firstName,
    lastName,
    emailAddress,
    passportNumber,
    city,
    area,
    streetName,
    building,
    floor,
    apartmentNo,
    fullAddress,
    isBillingSame,
    thirdName,
    secondName,
    applicationReferenceNumber,
    notes,
    receiptNumber,
    nationalIdNumber,
    purposeVisit,
    nationality,
    occupation,
    dateSlot,
    timeSlot,
    showUploadDocument,
    configuration,
    passportType
  } = values;

  const { locale } = values;
  const [cityLookup, setCityLookup] = useState([]);
  const [areaLookup, setAreaLookup] = useState([]);
  const [timeSlotLookup, setTimeSlot] = useState([]);
  const [dateSlotLookup, setDateSlot] = useState([]);
  const [isUploading, setUploading] = useState(false);
  const [attachedFile, setAttachedFile] = useState({ "id": '', "name": '' });
  const [visaExpiryDate, setVisaExpiryDate] = useState(null);
  const [passportExpiryDate, setPassportExpiryDate] = useState(null);
  const [passportIssueDate, setPassportIssueDate] = useState(null);
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [isSecondNameReqired, setIsSecondNameReqired] = useState(false);

  const expiryDistance = 15778476000;

  const {
    showNationalIdNumber,
    showPassportNumber,
    showFirstName,
    showLastName,
    showNotes,
    showReceiptNumber,
    showReferenceNumber,
    showDateCollect,
    isDelivery,
    hideEmirateIds,
    showExpiryDate,
    showOccupation,
    showDateOfBirth,
    showPassportIssueDate,
    showPurposeVisit,
    showNationality,
    showPassportType
  } = configuration;


  const [needsUploadDocument, setneedsUploadDocument] = useState(configuration.uploadDocument);
  const [showSecondName, setShowSecondName] = useState(configuration.showSecondName);
  const [showThirdName, setShowThirdName] = useState(configuration.showThirdName);


  const activeFields = [];

  if (showNationalIdNumber === 1) {
    activeFields.push("nationalIdNumber");
  }
 
  if (values.showDateCollect  === 1 && values.showUploadDocument === 0) {

    activeFields.push("dateSlot");
    activeFields.push("timeSlot");
  }

  if (showPassportNumber === 1) {
    activeFields.push("passportNumber");
  }

  if (showReceiptNumber === 1) {
    activeFields.push("receiptNumber");
  }

  if (parseInt(showReceiptNumber) === 1) {
    activeFields.push("receiptNumber");
  }

  if (parseInt(showFirstName) === 1) {
    activeFields.push("firstName");
  }

  if (parseInt(showLastName) === 1) {
    activeFields.push("lastName");
  }

  if (parseInt(showReferenceNumber) === 1) {
    activeFields.push("applicationReferenceNumber");
  }
  if (parseInt(showUploadDocument) === 1) {
    activeFields.push("attachment");
  }

  if (parseInt(showOccupation) === 1) {
    activeFields.push("occupation");
  }
  if (parseInt(showPassportIssueDate) === 1) {
    activeFields.push("passportIssueDate");
  }
  if (parseInt(showDateOfBirth) === 1) {
    activeFields.push("dateOfBirth");
  }
  if (parseInt(showExpiryDate) === 1) {
    activeFields.push("passportExpiryDate");
    activeFields.push("visaExpiryDate");

  }

  if (parseInt(showPurposeVisit) === 1) {
    activeFields.push("purposeVisit");
  }
  if (parseInt(showNationality) === 1) {
    activeFields.push("nationality");
  }
  const handlePassportExiryDateSelected = (date) => {
    var bday = new Date(date);
    let today = new Date();

    var distance = bday.getTime() - today.getTime();
    if (distance < expiryDistance) {
      setErrorMessage(t("PASSPORT_EXPIRY_DATE_ERROR"));
      setModalShow(true);
      setPassportExpiryDate('');
    }


  }

  const handleBirthDateChange = (date) => {
    setData({ name: "dateOfBirth", value: date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() });
    setDateOfBirth(date);
  };

  const handleBirthDateSelected = (date) => {
    var bday = new Date(date);
    let today = new Date();

    var distance = bday.getTime() - today.getTime();
    if (distance >= 0) {

      setErrorMessage(t("VISA_EXPIRY_DATE_ERROR"));
      setModalShow(true);
    }

  }

  const handlePassportIssueDateChange = (date) => {
    setData({ name: "passportIssueDate", value: date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() });
    setPassportIssueDate(date);
  };

  const handlePassportIssueDateSelected = (date) => {
    var bday = new Date(date);
    let today = new Date();

    var distance = bday.getTime() - today.getTime();
    if (distance >= 0) {

      setErrorMessage(t("VISA_EXPIRY_DATE_ERROR"));
      setModalShow(true);
      setPassportIssueDate('');
    }


  }

  const handleVisaExiryDateSelected = (date) => {
    var bday = new Date(date);
    let today = new Date();

    var distance = bday.getTime() - today.getTime();
    if (distance < expiryDistance) {

      setErrorMessage(t("VISA_EXPIRY_DATE_ERROR"));
      setModalShow(true);
      setVisaExpiryDate('');
    }


  }
  const handlePassportExpiryDateChange = (date) => {
    setData({ name: "passportExpiryDate", value: date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() });
    setPassportExpiryDate(date);

  };

  const handleVisaExpiryDateChange = (date) => {
    setVisaExpiryDate(date);
    setData({ name: "visaExpiryDate", value: date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() });

  };

  const handleCityChange = (event) => {

    handleOnChange(event);
    const cityCode = event.target.value;

    if (needsUploadDocument == 1) {
      setData({ name: "showUploadDocument", value: 1 });
      if (values.ignorUploadEmirateCodes) {
        if (values.ignorUploadEmirateCodes.includes(cityCode) == true) {
          setData({ name: "documentBase64", value: null });
          setData({ name: "showUploadDocument", value: 0 });
        }
      }
    }

    const selectedEmirate = cityLookup.find((city) => {
      return city.code === cityCode;
    });
    setData({
      name: "cityName",
      value: locale === "ar" ? selectedEmirate.nameAr : selectedEmirate.nameEn,
    });
    fetch(
      process.env.REACT_APP_MASTERS_API_BASE_URL +
      "/locations/api/Regions?EmirateId=" +
      selectedEmirate.id
    )
      .then((response) => response.json())
      .then((data) => {
        setAreaLookup(data.data.list);
      })
      .catch((error) => {
        console.log(error);
      });


    if (values.cashPaymentEmitateCodes)//switch to cash on delivery
    {
      if (values.cashPaymentEmitateCodes.includes(cityCode) == true)
        setData({ "name": "isOnlinePayment", "value": 0 });
      else
        setData({ "name": "isOnlinePayment", "value": 1 });
    }

  };



  const handleAttachmentUpload = (event) => {
    const uploadedFile = event.target.files[0];
    setUploading(true);
    setData([{ name: "attachedFile", value: uploadedFile }]);
    setAttachedFile(uploadedFile)
    handleFileChange(event, "attachment");

    const reader = new FileReader();
    reader.readAsDataURL(uploadedFile);
    reader.onload = () => {
      setData({ name: "documentBase64", value: reader.result });
      setUploading(false);
    };
  };

  const handleDateSlot = (event) => {
    handleOnChange(event);
  }

  const handleTimeSlot = (event) => {
    handleOnChange(event);
    setData({ "name": "timeSlotText", value: event.target[event.target.selectedIndex].text });
  }
  const handleAreaChange = (event) => {
    handleOnChange(event);
    const selectedArea = areaLookup.find((area) => {
      return area.code === event.target.value;
    });

    setData({ name: "areaName", value: selectedArea.nameEn });
    setData({ "name": "areaNameText", value: event.target[event.target.selectedIndex].text });
  };

  const handleBillingSelection = () => {
    setData({ name: "isBillingSame", value: isBillingSame ? false : true });
  };

  const isStepInvalid = () => {

    if (showDateCollect == 1  && showUploadDocument === 0) {
      activeFields.push("dateSlot");
      activeFields.push("timeSlot");
    }
    if (isSecondNameReqired) {
      activeFields.push("secondName");
      activeFields.push("thirdName");
    }

    const stepInputs = [
      ...activeFields,
      "emailAddress",
      "city",
      "area",
      "streetName",
      "apartmentNo",
    ];

    const stepBillingInputs = [
      "billingFirstName",
      "billingLastName",
      "billingCity",
      "billingCountry"
    ];
    let billingNullValues = [];
    let errorBillingValues = [];
    const nullValues = stepInputs.filter((input) => {
      return values[input] === "";
    });
    const errorValues = stepInputs.filter((input) => {
      return errors[input] !== "";
    });
    if (!isBillingSame) {
      billingNullValues = stepBillingInputs.filter((input) => {
        return values[input] === "";
      });
      errorBillingValues = stepBillingInputs.filter((input) => {
        return errors[input] !== "";
      });
    }

    return nullValues.length ||
      errorValues.length ||
      billingNullValues.length ||
      errorBillingValues.length
      ? true
      : false;
  };

  const handlCloseModal = () => {
    setModalShow(false);
  };


  const [modalShow, setModalShow] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {

    window.scrollTo(0, 0);

    fetch(
      process.env.REACT_APP_MASTERS_API_BASE_URL + "/locations/api/Emirates?IncludeCityAsEmirate=true"
    )
      .then((response) => response.json())
      .then((data) => {

        var cityList = data.data.list;
        if (hideEmirateIds) {
          var newCityList = [];
          var hideCityList = hideEmirateIds.split(",");
          cityList.map((item) => {
            var isValidCity = true;
            hideCityList.map((id) => {
              if (parseInt(item.id) === parseInt(id)) {
                isValidCity = false;
              }
            });
            if (isValidCity === true)
              newCityList.push(item);
          })
          cityList = newCityList;
        }
        setCityLookup(cityList);
        setData([{ name: "cityLookup", value: cityList }]);
      });


    //fetch dateslot

    fetch(
      process.env.REACT_APP_DATE_SLOT_BASE_URL
    )
      .then((response) => response.json())
      .then((data) => {
        setDateSlot(data.dateSlots);
        setTimeSlot(data.timeSlots);
      })
      .catch((error) => {
        console.log(error);
      });



    if (values.city) {
      fetch(
        process.env.REACT_APP_MASTERS_API_BASE_URL +
        "/locations/api/Regions?EmirateCode=" +
        values.city
      )
        .then((response) => response.json())
        .then((data) => {
          setAreaLookup(data.data.list);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    setShowSecondName(0);
    setShowThirdName(0);

    setIsSecondNameReqired(false);
    setData({ "name": "hideEnglishLanguage", "value": false });

   
   

    if (needsUploadDocument == '1' && ( values.citizenName == 'SUDAN' || values.citizenName=='SSUDAN')) {

      changeLanguageArabic();
      setShowSecondName(1);
      setShowThirdName(1);
      activeFields.push("secondName");
      activeFields.push("thirdName");
      setIsSecondNameReqired(true);
      setData({ "name": "hideEnglishLanguage", "value": true });

    }

  }, []);

  let isEmailFieldLong = true;

  if (showNationalIdNumber === 1) {
    isEmailFieldLong = false;
  }

  return (
    <>

      <Modal
        show={modalShow}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("ERROR")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5>{errorMessage}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handlCloseModal}>
            {t('CLOSE')}
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="receiver-section">
        <div className="row">
          <div className="col-sm-12">
            <h3>
              <img src="./images/user-icon.svg" alt="User Icon" />
              {t("ENTER_YOUR_DELIVERY_ADDRESS_DETAILS")}
            </h3>
          </div>
          {showFirstName === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="firstName"
                name="firstName"
                label={t("FIRST_NAME")}
                placeholder=""
                onChange={handleOnChange}
                value={firstName}
                required={true}
                validation={{ errors, dirty }}
                maxLength={100}
                t={t}
              />
            </div>
          )}

          {showSecondName === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="secondName"
                name="secondName"
                label={t("SECOND_NAME")}
                placeholder=""
                onChange={handleOnChange}
                value={secondName}
                required={isSecondNameReqired}
                validation={{ errors, dirty }}
                maxLength={100}
                t={t}
              />
            </div>
          )}

          {showThirdName === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="thirdName"
                name="thirdName"
                label={t("THIRD_NAME")}
                placeholder=""
                onChange={handleOnChange}
                value={thirdName}
                required={isSecondNameReqired}
                validation={{ errors, dirty }}
                maxLength={100}
                t={t}
              />
            </div>
          )}

          {showLastName === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="lastName"
                name="lastName"
                label={t("LAST_NAME")}
                placeholder=""
                onChange={handleOnChange}
                value={lastName}
                validation={{ errors, dirty }}
                maxLength={100}
                required={true}
                t={t}
              />
            </div>
          )}

          <div className="col-sm-6 mb-3">
            <div className="form-group">
              <SelectInput
                className="form-control form-select"
                id="city"
                name="city"
                label={showExpiryDate == 0 ? t("CITY") : t("VISA_CITY")}
                onChange={handleCityChange}
                value={city}
                validation={{ errors, dirty }}
                defaultText={t("SELECT_CITY")}
                itemLookUp={cityLookup}
                language={locale}
                required={true}
                t={t}
              />
            </div>
          </div>
          <div className="col-sm-6 mb-3">
            <div className="form-group">
              <SelectInput
                className="form-control form-select"
                id="area"
                name="area"
                label={t("AREA")}
                onChange={handleAreaChange}
                value={area}
                validation={{ errors, dirty }}
                defaultText={t("SELECT_AREA")}
                itemLookUp={areaLookup}
                language={locale}
                required={true}
                t={t}
              />
            </div>
          </div>


          {showExpiryDate === 1 &&
            <div className="col-sm-6 mb-3">
              <div className="form-group" >
                <label > {t("VISA_EXPIRY_DATE")}<span>*</span></label>

                <DatePicker
                  className="epg-calendar"
                  showIcon
                  selected={visaExpiryDate}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  adjustDateOnChange
                  dropdownMode="select"
                  onChange={handleVisaExpiryDateChange}
                  onSelect={handleVisaExiryDateSelected}
                  toggleCalendarOnIconClick
                  minDate={new Date().setMonth(6)}
                  showPopperArrow={true}
                  dateFormat="MMMM d, yyyy"
                  icon={<CalendarIcon > </CalendarIcon>}
                />

              </div>
            </div>
          }

          {showExpiryDate === 1 &&
            <div className="col-sm-6 mb-3">
              <div className="form-group" >
                <label> {t("PASSPORT_EXPIRY_DATE")}<span>*</span></label>
                <DatePicker
                  className="epg-calendar"
                  showIcon
                  selected={passportExpiryDate}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  adjustDateOnChange
                  dropdownMode="select"
                  toggleCalendarOnIconClick
                  onChange={handlePassportExpiryDateChange}
                  onSelect={handlePassportExiryDateSelected}
                  minDate={new Date().setMonth(6)}
                  dateFormat="MMMM d, yyyy"
                  icon={<CalendarIcon  > </CalendarIcon>}
                />
              </div>
            </div>
          }
          {showDateOfBirth === 1 &&
            <div className="col-sm-6 mb-3">
              <div className="form-group"   >
                <label> {t("DATE_OF_BIRTH")}<span>*</span></label>
                <DatePicker
                  id="dateOfBirth"
                  name="dateOfBirth"
                  className="epg-calendar"
                  showIcon
                  selected={dateOfBirth}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  adjustDateOnChange
                  dropdownMode="select"
                  toggleCalendarOnIconClick
                  showPopperArrow={false}
                  onChange={handleBirthDateChange}
                  onSelect={handleBirthDateSelected}
                  maxDate={new Date()}
                  dateFormat="MMMM d, yyyy"
                  icon={<CalendarIcon  > </CalendarIcon>}
                />
              </div>
            </div>
          }

          {showPassportIssueDate === 1 &&
            <div className="col-sm-6 mb-3">
              <div className="form-group">
                <label> {t("PASSPORT_ISSUE_DATE")}<span>*</span></label>
                <DatePicker
                  id="passportIssueDate"
                  name="passportIssueDate"
                  className="epg-calendar"
                  showIcon
                  selected={passportIssueDate}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  adjustDateOnChange
                  toggleCalendarOnIconClick
                  dropdownMode="select"
                  onChange={handlePassportIssueDateChange}
                  onSelect={handlePassportIssueDateSelected}
                  maxDate={new Date()}
                  dateFormat="MMMM d, yyyy"
                  icon={<CalendarIcon  > </CalendarIcon>}
                />
              </div>
            </div>
          }

          {showDateCollect === 1 && showUploadDocument === 0 && (
            <div
              className={"col-sm-6 mb-3"}
            >
              <SelectInput
                className="form-control form-select"
                id="dateSlot"
                name="dateSlot"
                value={dateSlot}
                onChange={handleDateSlot}
                label= { isDelivery==0 ?t('PREFERRED_DATE') : t('PREFERRED_DATE_DELIVERY')}
                validation={{ errors, dirty }}
                defaultText={t("SELECT_COLLECT_DATE")}
                itemLookUp={dateSlotLookup}
                language={values.locale}
                required={true}
                t={t}
              />
            </div>

          )}

          {showDateCollect === 1 && showUploadDocument === 0 && (

            <div
              className={"col-sm-6 mb-3"}
            >
              <SelectInput
                className="form-control form-select"
                id="timeSlot"
                name="timeSlot"
                value={timeSlot}                
                label= { isDelivery==0 ?t('PREFERRED_TIME') : t('PREFERRED_TIME_DELIVERY')}
                onChange={handleTimeSlot}
                validation={{ errors, dirty }}
                defaultText={t("SELECT_COLLECT_TIME")}
                itemLookUp={timeSlotLookup}
                language={values.locale}
                required={true}
                t={t}
              />

            </div>
          )}

          <div
            className={isEmailFieldLong ? "col-sm-12 mb-3" : "col-sm-6 mb-3"}
          >
            <TextInput
              id="emailAddress"
              name="emailAddress"
              label={t("EMAIL_ADDRESS")}
              placeholder=""
              onChange={handleOnChange}
              value={emailAddress}
              validation={{ errors, dirty }}
              maxLength={100}
              required={true}
              t={t}
            />
          </div>
          {showPassportNumber === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="passportNumber"
                name="passportNumber"
                label={t("PASSPORT_NUMBER")}
                placeholder=""
                onChange={handleOnChange}
                value={passportNumber}
                validation={{ errors, dirty }}
                required={true}
                t={t}
              />
            </div>
          )}

          {showNationalIdNumber === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="nationalIdNumber"
                name="nationalIdNumber"
                label={t("NATIONAL_ID_NUMBER")}
                placeholder=""
                onChange={handleOnChange}
                required={showNationalIdNumber === 1 ? true : false}

                value={nationalIdNumber}
                validation={{ errors, dirty }}
                t={t}
              />
            </div>
          )}
          {showReferenceNumber === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="applicationReferenceNumber"
                name="applicationReferenceNumber"
                label={t("USER_REFERENCE_NUMBER")}
                placeholder=""

                required={showReferenceNumber === 1 ? true : false}
                onChange={handleOnChange}
                value={applicationReferenceNumber}
                validation={{ errors, dirty }}
                t={t}
              />
            </div>
          )}
          {showReceiptNumber === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="receiptNumber"
                name="receiptNumber"
                label={t("RECEIPT_NUMBER")}
                placeholder=""
                required={showReceiptNumber === 1 ? true : false}
                onChange={handleOnChange}
                value={receiptNumber}
                validation={{ errors, dirty }}
                t={t}
              />
            </div>
          )}



          {showOccupation === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="occupation"
                name="occupation"
                label={t("OCCUPATION")}
                placeholder=""
                required={showOccupation === 1 ? true : false}
                onChange={handleOnChange}
                value={occupation}
                validation={{ errors, dirty }}
                t={t}
              />
            </div>
          )}

          {showPurposeVisit === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="purposeVisit"
                name="purposeVisit"
                label={t("PURPOSE_VISIT")}
                placeholder=""
                required={showPurposeVisit === 1 ? true : false}
                onChange={handleOnChange}
                value={purposeVisit}
                validation={{ errors, dirty }}
                t={t}
              />
            </div>
          )}

          {showNationality === 1 && (
            <div className="col-sm-6 mb-3">
              <TextInput
                id="nationality"
                name="nationality"
                label={t("NATIONALITY")}
                placeholder=""
                required={showNationality === 1 ? true : false}
                onChange={handleOnChange}
                value={nationality}
                validation={{ errors, dirty }}
                t={t}
              />
            </div>
          )}


          <div className="col-sm-6 mb-3">
            <TextInput
              id="streetName"
              name="streetName"
              label={t("STREET_NAME")}
              placeholder=""
              onChange={handleOnChange}
              value={streetName}
              validation={{ errors, dirty }}
              maxLength={200}
              required={true}
              t={t}
            />
          </div>
          <div className="col-sm-6 mb-3">
            <TextInput
              id="building"
              name="building"
              label={t("BUILDING")}
              placeholder=""
              onChange={handleOnChange}
              value={building}
              validation={{ errors, dirty }}
              maxLength={100}
              required={true}
              t={t}
            />
          </div>
          <div className="col-sm-6 mb-3">
            <TextInput
              id="floor"
              name="floor"
              label={t("FLOOR")}
              placeholder=""
              onChange={handleOnChange}
              value={floor}
              validation={{ errors, dirty }}
              maxLength={50}
              required={true}
              t={t}
            />
          </div>
          <div className="col-sm-6 mb-3">
            <TextInput
              id="apartmentNo"
              name="apartmentNo"
              label={t("APARTMENT_NO_VILLA")}
              placeholder=""
              onChange={handleOnChange}
              value={apartmentNo}
              validation={{ errors, dirty }}
              maxLength={100}
              required={true}
              t={t}
            />
          </div>
          <div className="col-sm-12 mb-3">
            <TextAreaInput
              id="fullAddress"
              name="fullAddress"
              label={t("FULL_ADDRESS")}
              placeholder=""
              onChange={handleOnChange}
              value={fullAddress}
              validation={{ errors, dirty }}
              rows={4}
              maxLength={200}
              t={t}
            />
          </div>
          {showNotes === 1 && (
            <div className="col-sm-12 mb-3">
              <TextAreaInput
                id="notes"
                name="notes"
                label={t("NOTES")}
                placeholder=""
                onChange={handleOnChange}
                value={notes}
                validation={{ errors, dirty }}
                rows={4}
                maxLength={200}
                t={t}
              />
            </div>
          )}

          {needsUploadDocument === 1 && showUploadDocument === 0 && (
            <div className="col-sm-8 mb-3">
              <h5>{t("ABU_DHABI_INSTRUCATION")}</h5>
              <ul>
                <li>
                  <span>{t("ABU_DHABI_INSTRUCATION_1")}</span>
                </li>
                <li>
                  <span>{t("ABU_DHABI_INSTRUCATION_2")}</span>
                </li>
              </ul>



            </div>
          )}

          {showUploadDocument === 1 && (
            <div className="form-group col-sm-12 mb-3">
              <label for="attachment">{t("UPLOAD_ATTACH")}<span>*</span></label>
              <FileUploadInput
                id="attachment"
                name="attachment"
                label={t("ATTACH_DOCUMENT")}
                placeholder=""
                onChange={handleAttachmentUpload}
                required={true}
                validation={{ errors, dirty }}
                maxLength={100}
                file={attachedFile}
                t={t}
              />

              <label style={{ paddingTop: "15px", color: "#8B0000" }}>{t('FILE_UPLOAD_INSTRUCTION')}</label>


              {isUploading && (
                <div className="inline-loader">
                  <EpInlineLoader />
                </div>
              )}

            </div>
          )

          }
        </div>
      </div>
      <div className="billing-section">
        <div className="row">
          <div className="col-sm-12">
            <div className="form-check my-4">
              <input
                className="form-check-input"
                name="isBillingSame"
                type="checkbox"
                value={isBillingSame}
                id="isBillingSame"
                checked={isBillingSame}
                onChange={handleBillingSelection}
              />
              <label className="form-check-label" htmlFor="flexCheckChecked">
                {t("MY_BILLING_AND_SHIPPING_ADDRESS_ARE_SAME")}
              </label>
            </div>
          </div>
        </div>
        <div className="col-sm-12">
          {!isBillingSame && <BillingDetails {...props} />}
        </div>
      </div>
      <div className="row">

        <div className="col-6 my-3 dir-left">
          <button
            className="btn btn-lg btn-default btn-back "
            onClick={() => {
              if (values.serviceTypeCode === "ATTEST") navigation.go("attestation-service");
              else if (values.serviceTypeCode === "GOOD") navigation.go("good-enter-details");
              else navigation.go("select-embassy");
            }}
            disabled={false}
          >
            <img src="./images/arrow-left.svg" alt="" />
            {t("BACK")}
          </button>
        </div>

        <div className="col-6 my-3  dir-right">
          <button
            className="btn btn-primary btn-lg emx-button"
            onClick={() => {
              values.isMobileVerified
                ? navigation.go("review-details")
                : navigation.next();
            }}
            disabled={isStepInvalid()}
          >
            {t("PROCEED")}
          </button>
        </div>
      </div>
    </>
  );
}

export default AddressDetails;
